// extracted by mini-css-extract-plugin
export default {"container":"WorkspacesContainer_container__e6HL9"};